/*
 * ep-pergola.js — SkyShade Pro Pergola-Konfigurator, Englputzeder (portiert von my-Harry mh-pergola.js, 22.10.2026)
 * Änderungen ggü. my-Harry: Sie-Form, de-AT, Streichpreis nur wenn > Preis (EP-Datenfehler 3x5/4x5),
 * Glaswand nur wenn verfügbar, Warenkorb-Drawer über Enterprise-Events (dispatch:cart-drawer:refresh/open).
 * Set-Builder (Rollos je Seite, Heizung), Zusammenstellung, Set in den Warenkorb.
 * Größe/Farbe wechseln ohne Neuladen: die Zielseite wird im Hintergrund geladen und nur die
 * produktabhängigen Bereiche werden ersetzt (URL, Titel und Zurück-Taste funktionieren normal).
 * Daten: <script id="mhpg-data"> aus snippets/ep-pergola-config.liquid (Preise in Cent).
 * Schnittstelle für assets/ep-pergola-extras.js: window.MHPG.model()
 * 28.10.2026: Event 'mh:konf:final' (key pergola) nach jedem render() für das anonyme Autosave der Suite.
 */
(function () {
  'use strict';
  if (window.MHPG && window.MHPG.boot) return;

  // Maße aus den Herstellerunterlagen (Pfosten außen in m), Lamellen je Feld
  var SIZES = {
    '3x3': { w: 3, d: 3, ow: 2.94, od: 2.94, conf: true,  posts: 4, fields: 1, blades: 18 },
    '3x4': { w: 4, d: 3, ow: 3.94, od: 2.94, conf: true,  posts: 4, fields: 1, blades: 25 },
    '3x5': { w: 5, d: 3, ow: 4.94, od: 2.94, conf: false, posts: 6, fields: 2, blades: 18 },
    '4x5': { w: 5, d: 4, ow: 4.94, od: 3.94, conf: false, posts: 6, fields: 2, blades: 25 }
  };
  var RAL = {
    anthrazit:  { hex: '#383E42', rollo: '#4a4f53', name: 'Anthrazit (RAL 7016)' },
    seidengrau: { hex: '#CAC4B0', rollo: '#d8d2c6', name: 'Seidengrau (RAL 7044)' }
  };
  // Seiten: 0 oben = hinten (Längsseite), 1 rechts (Stirnseite), 2 unten = vorne (Längsseite), 3 links (Stirnseite)
  var SIDE_NAMES = ['hinten', 'rechts', 'vorne', 'links'];
  var SIDE_LONG = ['Längsseite hinten', 'Stirnseite rechts', 'Längsseite vorne', 'Stirnseite links'];

  var D = null, S = null;
  var state = { sides: ['offen', 'offen', 'offen', 'offen'], glas: [false, false, false, false], heat: 0, open: false };

  var fmtEUR;
  try { fmtEUR = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' }); } catch (e) { fmtEUR = null; }
  function money(cents) { var v = (cents || 0) / 100; return fmtEUR ? fmtEUR.format(v) : v.toFixed(2).replace('.', ',') + ' €'; }
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function de(n) { return String(n).replace('.', ','); }

  function sideLen(i) { return (i % 2 === 0) ? S.w : S.d; }
  function rollosForLen(len) { return len === 5 ? [{ len: '2.5', n: 2 }] : [{ len: String(len), n: 1 }]; }
  function rolloVar(len) {
    var r = (D.rollo[D.color] && D.rollo[D.color][len]) || (D.rollo.anthrazit && D.rollo.anthrazit[len]);
    return r && r.id ? r : null;
  }
  function rolloPrice(i) {
    return rollosForLen(sideLen(i)).reduce(function (t, r) { var v = rolloVar(r.len); return t + (v ? v.price * r.n : 0); }, 0);
  }
  // Glaswand-Elemente: nur für Seiten mit 3 m oder 4 m (zwischen zwei Pfosten), Farben laut D.glasColors
  function glasVar(len) {
    if (!D.glas || (D.glasColors || '').split(',').indexOf(D.color) < 0) return null;
    var g = D.glas[String(len)];
    return g && g.id && g.avail !== false ? g : null;
  }
  // Streichpreis nur, wenn er über dem Preis liegt (EP: Pergola 3x5/4x5 haben Streichpreis < Preis → ignorieren)
  function cmpOf(v) { return (v.cmp && v.cmp > v.price) ? v.cmp : v.price; }
  function glasAny() { return [0, 1, 2, 3].some(function (i) { return !!glasVar(sideLen(i)); }); }

  function lines() {
    var out = [], agg = {};
    out.push({ label: D.title, qty: 1, unit: D.pergola.price, price: D.pergola.price, cmp: cmpOf(D.pergola), id: D.pergola.id, img: D.pergola.img });
    state.sides.forEach(function (st, i) {
      if (st !== 'rollo') return;
      rollosForLen(sideLen(i)).forEach(function (r) {
        var v = rolloVar(r.len); if (!v) return;
        agg[r.len] = agg[r.len] || { v: v, n: 0, s: [] }; agg[r.len].n += r.n; agg[r.len].s.push(SIDE_NAMES[i]);
      });
    });
    Object.keys(agg).sort().forEach(function (k) {
      var a = agg[k];
      out.push({ label: 'Sichtschutz-Rollo ' + de(k) + ' m', qty: a.n, unit: a.v.price, price: a.v.price * a.n, cmp: cmpOf(a.v) * a.n, id: a.v.id, img: a.v.img, chip: a.s.join(' + ') });
    });
    var gl = {};
    state.glas.forEach(function (on, i) {
      if (!on) return;
      var len = sideLen(i), v = glasVar(len); if (!v) return;
      gl[len] = gl[len] || { v: v, n: 0, s: [] }; gl[len].n += 1; gl[len].s.push(SIDE_NAMES[i]);
    });
    Object.keys(gl).sort().forEach(function (k) {
      var a = gl[k];
      out.push({ label: 'Glaswand-Element ' + de(k) + ' m', qty: a.n, unit: a.v.price, price: a.v.price * a.n, cmp: cmpOf(a.v) * a.n, id: a.v.id, img: a.v.img, chip: a.s.join(' + '), glas: true });
    });
    if (state.heat > 0 && D.heat) out.push({ label: 'Infrarot-Heizung 1.800 W', qty: state.heat, unit: D.heat.price, price: D.heat.price * state.heat, cmp: cmpOf(D.heat) * state.heat, id: D.heat.id, img: D.heat.img });
    var total = out.reduce(function (t, l) { return t + l.price; }, 0);
    var cmp = out.reduce(function (t, l) { return t + l.cmp; }, 0);
    return { items: out, total: total, cmp: cmp };
  }

  // Pro Seite entweder Rollo oder Glaswand (laut Hersteller nicht kombinierbar)
  function toggleSide(i) { if (state.glas[i]) return; state.sides[i] = state.sides[i] === 'rollo' ? 'offen' : 'rollo'; render(); }
  function toggleGlas(i) { if (state.sides[i] === 'rollo') return; state.glas[i] = !state.glas[i]; render(); }

  function drawPlan() {
    var el = $('mhpg-plan'); if (!el) return;
    var maxW = 180, maxH = 130, sc = Math.min(maxW / S.w, maxH / S.d), W = Math.round(S.w * sc), H = Math.round(S.d * sc);
    el.style.gridTemplateColumns = '26px ' + W + 'px 26px';
    el.style.gridTemplateRows = '26px ' + H + 'px 26px';
    var pos = ['t', 'r', 'b', 'l'];
    el.innerHTML = [0, 1, 2, 3].map(function (i) {
      var on = state.sides[i] === 'rollo', g = !!state.glas[i];
      return '<button type="button" class="pb pb--' + pos[i] + (i % 2 ? ' pb--v' : '') + (g ? ' is-glas' : '') + '" data-side="' + i + '" aria-pressed="' + on + '"' + (g ? ' aria-disabled="true"' : '') + ' aria-label="' + SIDE_LONG[i] + (on ? ', Rollo gewählt' : g ? ', Glaswand gewählt, kein Rollo möglich' : ', ohne Rollo') + '"><span>' + (g ? 'Glas' : SIDE_NAMES[i]) + '</span></button>';
    }).join('') + '<div class="ctr"><b>' + S.d + ' × ' + S.w + ' m</b>ca. ' + (S.d * S.w) + ' m²</div>';
    el.querySelectorAll('.pb').forEach(function (b) {
      b.addEventListener('click', function () { var i = +b.dataset.side; toggleSide(i); var n = el.querySelector('[data-side="' + i + '"]'); if (n) n.focus(); });
    });
  }

  function drawList() {
    var el = $('mhpg-rlist'); if (!el) return;
    el.innerHTML = [0, 2, 3, 1].map(function (i) {
      var len = sideLen(i), n = rollosForLen(len)[0];
      var extra = n.n > 1 ? ' · 2 Rollos à 2,5 m' : '';
      var avail = !!rolloVar(n.len), on = state.sides[i] === 'rollo', blk = !!state.glas[i];
      var rec = (i % 2 === 0) ? '<span class="mhpg-recbadge">Empfohlen</span>' : '';
      return '<label class="mhpg-tg' + (on ? ' on' : '') + (avail ? '' : ' is-disabled') + (blk ? ' is-blocked' : '') + '"><input type="checkbox" data-side="' + i + '"' + (on ? ' checked' : '') + (avail && !blk ? '' : ' disabled') + '><span class="tk" aria-hidden="true"></span><span class="tx">' + rec + '<b>' + SIDE_LONG[i] + '</b><small>' + de(len) + ' m Seitenlänge' + extra + '</small>' + (blk ? '<span class="mhpg-chip mhpg-chip--g">Glaswand gewählt · kein Rollo möglich</span>' : '') + '</span><span class="pr">' + (avail ? money(rolloPrice(i)) : 'auf Anfrage') + '</span></label>';
    }).join('');
    el.querySelectorAll('input').forEach(function (c) { c.addEventListener('change', function () { toggleSide(+c.dataset.side); }); });
    var cnt = state.sides.filter(function (x) { return x === 'rollo'; }).length;
    if ($('mhpg-rollo-status')) $('mhpg-rollo-status').textContent = cnt ? (cnt === 1 ? '1 Seite gewählt' : cnt + ' Seiten gewählt') : 'keine gewählt';
  }

  // 13.10.2026: Hinweis je Wandtyp – 3 m: 3 Flügel auf 3 Schienen, lassen sich auf beide Seiten schieben; 4 m: Doppeltür, öffnet in der Mitte
  function drawGlas() {
    var sec = $('mhpg-glas-sec'), el = $('mhpg-glist'); if (!sec || !el) return false;
    var any = glasAny();
    sec.hidden = !any;
    if (!any) { el.innerHTML = ''; return false; }
    var skipped = [];
    el.innerHTML = [0, 2, 3, 1].map(function (i) {
      var len = sideLen(i), v = glasVar(len);
      if (!v) { skipped.push(SIDE_LONG[i]); return ''; }
      var on = !!state.glas[i], blk = state.sides[i] === 'rollo';
      return '<label class="mhpg-tg mhpg-tg--glas' + (on ? ' on' : '') + (blk ? ' is-blocked' : '') + '"><input type="checkbox" data-side="' + i + '"' + (on ? ' checked' : '') + (blk ? ' disabled' : '') + '><span class="tk" aria-hidden="true"></span><span class="tx"><b>' + SIDE_LONG[i] + '</b><small>' + de(len) + ' m Glas-Schiebewand' + (len === 3 ? ' · 3 Flügel, nach links oder rechts schiebbar' : ' · 4 Flügel, öffnet in der Mitte') + '</small>' + (blk ? '<span class="mhpg-chip">Rollo gewählt · keine Glaswand möglich</span>' : '') + '</span><span class="pr">' + money(v.price) + '</span></label>';
    }).join('');
    el.querySelectorAll('input').forEach(function (c) { c.addEventListener('change', function () { toggleGlas(+c.dataset.side); }); });
    var note = $('mhpg-glas-note');
    if (note) { note.hidden = !skipped.length; note.textContent = skipped.length ? 'Für 5-m-Seiten gibt es derzeit keine Glaswand (' + skipped.join(', ') + ').' : ''; }
    var cnt = state.glas.filter(Boolean).length;
    if ($('mhpg-glas-status')) $('mhpg-glas-status').textContent = cnt ? (cnt === 1 ? '1 Seite gewählt' : cnt + ' Seiten gewählt') : 'keine gewählt';
    return true;
  }

  function render() {
    drawPlan(); drawList();
    var hasGlas = drawGlas();
    if ($('mhpg-plan-legend')) $('mhpg-plan-legend').hidden = !hasGlas;
    if ($('mhpg-wl-no')) $('mhpg-wl-no').textContent = hasGlas ? '3.3' : '3.2';
    if ($('mhpg-sb-ht')) $('mhpg-sb-ht').textContent = hasGlas ? 'Rollos, Glaswände und Heizung hinzufügen' : 'Rollos und Heizung hinzufügen';
    var r = lines();
    var sum = $('mhpg-sum-lines');
    if (sum) sum.innerHTML = r.items.map(function (l) {
      return '<div class="mhpg-zl">' + (l.img ? '<img src="' + esc(l.img) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="ph-img"></span>') +
        '<span><b>' + esc(l.label) + '</b>' + (l.chip ? '<span class="mhpg-chip">' + l.chip + '</span>' : '') + '<small>' + l.qty + ' Stück · ' + money(l.unit) + '</small></span>' +
        '<span class="mhpg-num mhpg-zl__pr">' + (l.cmp > l.price ? '<s>' + money(l.cmp) + '</s>' : '') + money(l.price) + '</span></div>';
    }).join('');
    if ($('mhpg-sum-total')) $('mhpg-sum-total').textContent = money(r.total);
    if ($('mhpg-sum-cmp')) { $('mhpg-sum-cmp').hidden = !(r.cmp > r.total); $('mhpg-sum-cmp').textContent = money(r.cmp); }
    if ($('mhpg-heat-qty')) $('mhpg-heat-qty').textContent = state.heat;
    if ($('mhpg-heat-rec')) $('mhpg-heat-rec').textContent = S.posts === 6 ? '2 empfohlen' : '1 empfohlen';
    if ($('mhpg-heat-price') && D.heat) $('mhpg-heat-price').textContent = money(D.heat.price);
    var nr = r.items.filter(function (l) { return l.chip && !l.glas; }).reduce(function (t, l) { return t + l.qty; }, 0);
    var ng = r.items.filter(function (l) { return l.glas; }).reduce(function (t, l) { return t + l.qty; }, 0);
    var isSet = r.items.length > 1;
    if ($('mhpg-sb-sub')) $('mhpg-sb-sub').textContent = isSet
      ? [nr ? nr + (nr === 1 ? ' Rollo' : ' Rollos') : '', ng ? ng + (ng === 1 ? ' Glaswand' : ' Glaswände') : '', state.heat ? state.heat + (state.heat === 1 ? ' Heizung' : ' Heizungen') : ''].filter(Boolean).join(' · ') + ' · Set ' + money(r.total)
      : (hasGlas ? 'Optional: Rollos, Glaswände und Heizung passend zur Größe' : 'Optional: Rollos und Heizung passend zur Größe');
    // Preisanzeige (ersetzt den Theme-Preisblock): Set-Summe und Streichpreis-Summe
    if ($('mhpg-p-now')) $('mhpg-p-now').textContent = money(r.total);
    if ($('mhpg-p-cmp')) $('mhpg-p-cmp').textContent = money(r.cmp);
    if ($('mhpg-p-reg')) $('mhpg-p-reg').hidden = !(r.cmp > r.total);
    if ($('mhpg-p-lbl')) $('mhpg-p-lbl').textContent = isSet ? 'Ihr Set-Preis' : 'Ihr Preis';
    if ($('mhpg-p-set')) { $('mhpg-p-set').hidden = !isSet; $('mhpg-p-set').textContent = isSet ? 'Pergola ' + money(D.pergola.price) + ' + Zubehör ' + money(r.total - D.pergola.price) : ''; }
    var atc = $('mhpg-atc');
    if ($('mhpg-atc-label') && atc && !atc.hasAttribute('data-na')) $('mhpg-atc-label').textContent = isSet ? 'Komplettes Set in den Warenkorb' : 'In den Warenkorb legen';
    var cnt = r.items.reduce(function (t, l) { return t + l.qty; }, 0);
    if ($('mhpg-atc-sum')) {
      $('mhpg-atc-sum').hidden = !isSet;
      $('mhpg-atc-sum').innerHTML = isSet ? 'Ihr Set: ' + cnt + ' Artikel · <b class="mhpg-num">' + money(r.total) + '</b>' : '';
    }
    // 28.10.2026: Zusammenstellung steht (Set-Preis) -> anonymes Autosave ueber ep-konf-suite.js (Punkt 18).
    // Nur technische Daten, keine Kundendaten. Die Suite entprellt und dedupliziert selbst.
    try {
      document.dispatchEvent(new CustomEvent('mh:konf:final', { detail: { key: 'pergola', final: isSet, data: {
        modell: D.key, farbe: D.color, titel: D.title, masse: S.d + ' × ' + S.w + ' m',
        seiten: state.sides.slice(), glas: state.glas.slice(), heizung: state.heat,
        positionen: r.items.map(function (l) { return { id: l.id, titel: l.label, menge: l.qty, preis: l.price, seiten: l.chip || '' }; }),
        preis: r.total, streichpreis: r.cmp
      } } }));
    } catch (e) {}
  }

  function bindToggle(btnId, bodyId, labels, onChange) {
    var b = $(btnId), body = $(bodyId); if (!b || !body) return;
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open); body.hidden = !open;
      if (labels) b.textContent = open ? labels[0] : labels[1];
      if (onChange) onChange(open);
    });
  }

  function addToCart() {
    var btn = $('mhpg-atc'), err = $('mhpg-atc-error');
    if (!btn || btn.disabled) return;
    var r = lines();
    // 02.11.2026: Rollo/Glaswand: gewählte Seite(n) als sichtbare Eigenschaft (z. B. Seite: hinten; mehrere: Seiten: hinten + vorne)
    var items = r.items.map(function (l) { var p = r.items.length > 1 ? { _set: 'SkyShade Pro ' + D.key } : {}; if (l.chip) p[l.chip.indexOf(' + ') >= 0 ? 'Seiten' : 'Seite'] = l.chip; return { id: l.id, quantity: l.qty, properties: p }; });
    btn.disabled = true; btn.classList.add('is-loading'); if (err) err.hidden = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Fehler');
        // Enterprise 1.4.2: Drawer neu laden und öffnen; ohne Drawer (Warenkorb-Typ „Seite“) zum Warenkorb
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          setTimeout(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: btn } })); }, 150);
        } else {
          location.href = root + 'cart';
        }
        document.dispatchEvent(new CustomEvent('ep:konfigurator:added', { detail: { konfigurator: 'pergola', items: items, response: x.j } }));
      })
      .catch(function (e) {
        if (err) { err.textContent = 'Das hat nicht geklappt: ' + e.message + ' Bitte versuchen Sie es noch einmal oder rufen Sie uns an.'; err.hidden = false; }
      })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }

  // Startet den Konfigurator für das aktuell angezeigte Modell (beim Laden und nach jedem Wechsel)
  function boot() {
    var dataEl = $('mhpg-data');
    if (!dataEl) return false;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('ep-pergola: Daten fehlerhaft', e); return false; }
    S = SIZES[D.key];
    if (!S) return false;
    if (state.heat > 4) state.heat = 4;
    state.glas = state.glas.map(function (on, i) { return on && !!glasVar(sideLen(i)) && state.sides[i] !== 'rollo'; });
    bindToggle('mhpg-sb-toggle', 'mhpg-sb-body', null, function (open) { state.open = open; });
    bindToggle('mhpg-zs-toggle', 'mhpg-zs-body', ['Zuklappen', 'Aufklappen']);
    if (state.open && $('mhpg-sb-toggle') && $('mhpg-sb-body')) { $('mhpg-sb-toggle').setAttribute('aria-expanded', 'true'); $('mhpg-sb-body').hidden = false; }
    var ct = $('mhpg-custom-toggle');
    if (ct) ct.addEventListener('click', function () {
      var open = ct.getAttribute('aria-expanded') !== 'true';
      ct.setAttribute('aria-expanded', open); $('mhpg-custom-panel').hidden = !open;
    });
    if ($('mhpg-heat-plus')) $('mhpg-heat-plus').addEventListener('click', function () { if (state.heat < 4) { state.heat++; render(); } });
    if ($('mhpg-heat-minus')) $('mhpg-heat-minus').addEventListener('click', function () { if (state.heat > 0) { state.heat--; render(); } });
    if ($('mhpg-atc')) { if ($('mhpg-atc').disabled) $('mhpg-atc').setAttribute('data-na', ''); $('mhpg-atc').addEventListener('click', addToCart); }
    render();
    return true;
  }

  // ---------- Größe/Farbe wechseln ohne Neuladen ----------
  var pages = {};          // URL -> Promise<HTML>
  var shownDoc = null;     // geparste Fassung der gerade angezeigten Seite (zum Vergleichen)
  var busy = false;
  function clean(u) { var x = new URL(u, location.href); x.hash = ''; return x.pathname + x.search; }
  function load(u) {
    var k = clean(u);
    if (!pages[k]) {
      pages[k] = fetch(k, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      pages[k].catch(function () { delete pages[k]; });
    }
    return pages[k];
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function sectionsOf(doc) { return [].slice.call(doc.querySelectorAll('.shopify-section[id^="shopify-section-template--"]')); }
  // Einmal geladene Skripte (auch wenn ihr Tag beim Austausch entfernt wurde) nicht erneut ausführen
  var loadedSrc = {};
  document.querySelectorAll('script[src]').forEach(function (s) { loadedSrc[s.src.split('?')[0]] = true; });
  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var t = (old.type || '').toLowerCase();
      if (t && t !== 'text/javascript' && t !== 'module' && t !== 'application/javascript') return; // JSON, ld+json
      if (old.src) {
        var base = old.src.split('?')[0], loaded = !!loadedSrc[base];
        document.querySelectorAll('script[src]').forEach(function (s) { if (s !== old && !root.contains(s) && s.src.split('?')[0] === base) loaded = true; });
        if (loaded) return;
        loadedSrc[base] = true;
      } else if (/mhpg-gallery/.test(old.textContent)) {
        return; // Galerie-Verschiebung erledigt moveGallery()
      }
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      if (!old.src) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }
  // Bereits verdrahtete Elemente (Ansicht-Buttons, Merkmal-Kacheln) übernehmen statt neu zu binden
  function keep(id, node) {
    var n = $(id);
    if (node && n && node !== n) n.parentNode.replaceChild(node, n);
  }
  function moveGallery() {
    var n = $('mhpg-gallery');
    var c = document.getElementById('product-media');
    if (!n || !c) return;
    if (n.parentNode !== c) c.appendChild(n);
    n.classList.add('is-moved');
  }
  function swap(url, push) {
    if (busy) return;
    busy = true;
    var sel = $('mhpg-select');
    if (sel) { sel.style.transition = 'opacity .15s'; sel.style.opacity = '.55'; sel.style.pointerEvents = 'none'; }
    var oldGal = $('mhpg-gallery'), oldTools = $('mhpg-tools');
    var y = window.scrollY;
    var prev = shownDoc ? Promise.resolve(shownDoc) : load(location.href).then(parse);
    Promise.all([load(url).then(parse), prev]).then(function (r) {
      var doc = r[0], before = r[1];
      if (!doc.getElementById('mhpg-data')) throw new Error('keine Pergola-Seite');
      sectionsOf(doc).forEach(function (ns) {
        var os = document.getElementById(ns.id);
        if (!os) return;
        var bs = before.getElementById(ns.id);
        if (bs && bs.innerHTML === ns.innerHTML) return; // unverändert, z. B. USPs, Videos
        var imp = document.importNode(ns, true);
        os.parentNode.replaceChild(imp, os);
        runScripts(imp);
      });
      keep('mhpg-gallery', oldGal);
      keep('mhpg-tools', oldTools);
      moveGallery();
      // 02.11.2026: media-gallery wird per importNode ausserhalb des DOM initialisiert (clientWidth 0 -> Zaehler "1 / 0", Pfeile ohne Funktion) -> im DOM neu initialisieren
      document.querySelectorAll('media-gallery').forEach(function (g) {
        try { if (typeof g.initGallery === 'function' && !(g.visibleItems && g.visibleItems.length) && !(g.dataset.layout === 'stacked' && window.theme && theme.mediaMatches && theme.mediaMatches.md)) g.initGallery(); } catch (e) {}
      });
      if (doc.title) document.title = doc.title;
      if (push) history.pushState({ mhpg: true }, '', url);
      shownDoc = doc;
      boot();
      window.scrollTo(0, y);
      try { if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') window.jdgm.initializeWidgets(); } catch (e) {}
      document.dispatchEvent(new CustomEvent('mhpg:switched', { detail: { url: url, key: D && D.key, color: D && D.color } }));
    }).catch(function () {
      location.href = url; // Rückfall: normal laden
    }).finally(function () {
      busy = false;
      var s2 = $('mhpg-select');
      if (s2) { s2.style.opacity = ''; s2.style.pointerEvents = ''; }
    });
  }
  function linkFrom(e) {
    var a = e.target && e.target.closest ? e.target.closest('a.mhpg-size, a.mhpg-color') : null;
    return a && a.href ? a : null;
  }
  document.addEventListener('click', function (e) {
    var a = linkFrom(e);
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (a.getAttribute('aria-current') === 'true') return;
    swap(a.href, true);
  });
  function prefetch(e) { var a = linkFrom(e); if (a && a.getAttribute('aria-current') !== 'true') load(a.href); }
  document.addEventListener('mouseover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.mhpg && $('mhpg-data')) swap(location.href, false);
  });

  // Schnittstelle für ep-pergola-extras.js (Montageskizze, 3D, AR, Live)
  window.MHPG = {
    boot: boot,
    model: function () {
      var c = RAL[D.color] || RAL.anthrazit;
      return {
        key: D.key, w: S.w, d: S.d, ow: S.ow, od: S.od, conf: S.conf, h: 2.46,
        posts: S.posts, fields: S.fields, blades: S.blades,
        color: c.hex, rollo: c.rollo, colorName: c.name,
        sides: state.sides.slice(), glas: state.glas.slice(), label: S.d + ' × ' + S.w + ' m'
      };
    }
  };

  function start() {
    if (!boot()) return;
    try { history.replaceState(Object.assign({}, history.state || {}, { mhpg: true }), '', location.href); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();